
import PropTypes from 'prop-types';
import React from 'react';
import resetScrollState from '../utils/reset-scroll-state';

class ScrollToTopOnLocationChange extends React.Component {
    componentDidMount() {
        resetScrollState();
    }
    componentDidUpdate({ location, handleScroll }) {
        if (handleScroll === 'mobile' && window.innerWidth > 700) {
            return;
        }
        if (location !== this.props.location) {
            resetScrollState();
        }
    }
    render() {
        return null;
    }
}

ScrollToTopOnLocationChange.propTypes = {
    location: PropTypes.string,
};

export default ScrollToTopOnLocationChange;



// WEBPACK FOOTER //
// ./src/client/Components/ScrollToTopOnLocationChange.js